import { PromptPair } from "./Wazawan";
import { ExternalLink, Maximize2 } from "lucide-react";
import "./WazawanAssetPreview.css";

type WazawanAssetPreviewProps = {
    promptPair: PromptPair;
    onExpand: (promptPair: PromptPair) => void;
}

export const WazawanAssetPreview = ({promptPair, onExpand} : WazawanAssetPreviewProps) => {
    
    const response = JSON.parse(promptPair.response);

    const toDisplay = response.title ? response.title : response.url;

    return (
        <div
            className="wazawan-asset-preview"
            onClick={()=>window.open(response.cloudURL, "_blank")}
        >

            {toDisplay}
           
            <div className="wazawan-asset-preview-actions">
                <div 
                    className="wazawan-asset-preview-expand"
                    onClick={(e: any)=>{
                        onExpand(promptPair)
                        e.stopPropagation()
                    }}
                >
                    <Maximize2 size={16} />
                </div>
                {/* <div 
                    className="wazawan-asset-preview-open"
                >
                    <ExternalLink size={16} />
                </div> */}

            </div>
            
        </div>        
    )
}